import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetLastRecommendationTrainTimeParams {
}

export interface IGetLastRecommendationTrainTimeResult {
  time: string; // e.g. "2015-05-20T12:00:00.000Z"
}

export class GetLastRecommendationTrainTimeRequest extends Request<IGetLastRecommendationTrainTimeParams, IGetLastRecommendationTrainTimeResult> {
  constructor(params: IGetLastRecommendationTrainTimeParams = {}) {
    super('getLastRecommendationTrainTime', params);
  }
}
